export default __webpack_public_path__ + "static/media/check.b6be190e.svg";